// web-staking-estimator-frontend/src/lib/api.js

/*
 * Simple GET helper that appends query params and returns JSON
 * Supports cross-origin via REACT_APP_API_BASE for linuxdev deploys
 * Falls back to same-origin (window.location.origin) for normal Docker setups
 */
const API_BASE =
  (typeof process !== "undefined" &&
    process.env &&
    process.env.REACT_APP_API_BASE) ||
  window.location.origin;

export async function apiGet(path, params) {
  const url = new URL(path, API_BASE);
  if (params) {
    for (const [k, v] of Object.entries(params)) {
      if (v !== undefined && v !== null) url.searchParams.set(k, String(v));
    }
  }
  const res = await fetch(url.toString(), { method: "GET" });
  if (!res.ok) throw new Error(`GET ${url} -> ${res.status}`);
  return res.json();
}

// POST JSON to API, returns parsed JSON response or throws on error
export async function apiPost(path, body) {
  const url = new URL(path, API_BASE);
  const res = await fetch(url.toString(), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body ?? {})
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`POST ${url} -> ${res.status}${text ? `: ${text}` : ""}`);
  }
  return res.json();
}
